import { useQuery } from '@tanstack/vue-query'
import { toValue, type MaybeRefOrGetter } from 'vue'
import { orderKeys } from '../orderQueryKeys'
import { calculateFees } from '../orderEndpoints'
import { parseCalculateFees } from '../orderParser'

export function useCalculateFeesQuery(
  offeringId: MaybeRefOrGetter<string | null | undefined>,
  tokenQuantity: MaybeRefOrGetter<number>,
) {
  return useQuery({
    queryKey: () => orderKeys.calculateFees(toValue(offeringId) ?? '', toValue(tokenQuantity)),
    queryFn: () =>
      calculateFees(toValue(offeringId) ?? '', toValue(tokenQuantity)).then(parseCalculateFees),
    enabled: () => Boolean(toValue(offeringId)) && toValue(tokenQuantity) > 0,
  })
}
